const TENANT_KEY = 'vms.login.tenant';

/** The organisation last used to sign in on this browser (a convenience only). */
export function readTenant(): string {
  try {
    return localStorage.getItem(TENANT_KEY) ?? '';
  } catch {
    return '';
  }
}

export function rememberTenant(slug: string) {
  try {
    localStorage.setItem(TENANT_KEY, slug);
  } catch {
    /* storage unavailable */
  }
}
